import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { CURRENCY_SYMBOL } from "../../config";
const UserInfoHeader = () => {
  const [renewalDate, setRenewalDate] = useState("");
  const [daysLeft, setDaysLeft] = useState("");
  const [totalDays, setTotalDays] = useState("");

  const userAccountInfo = useSelector(
    (state) => state?.CommonReducer?.accountInfo,
  );

  const subscriptionaccountInfo = useSelector(
    (state) => state?.CommonReducer?.subscriptionaccountInfo,
  );
  const usageAccountInfo = useSelector(
    (state) => state?.CommonReducer?.usageaccountInfo,
  );
  useEffect(() => {
    if (
      Object.keys(subscriptionaccountInfo).length &&
      subscriptionaccountInfo?.validTo &&
      subscriptionaccountInfo?.offerStartDate
    ) {
      let validToDate = moment(subscriptionaccountInfo.validTo)
        .utc()
        .format(" MMM DD, YYYY");
      let renewalDate1 = moment(subscriptionaccountInfo?.validTo)
        .utc()
        .add(1, "d")
        .format(" MMM DD, YYYY");
      setRenewalDate(renewalDate1);
      let activationDate = moment(subscriptionaccountInfo.offerStartDate)
        .utc()
        .format(" MMM DD, YYYY");

      let todayDate = moment().utc().format(" MMM DD, YYYY");

      let startDate = moment(todayDate, " MMM DD, YYYY");
      let endDate = moment(validToDate, " MMM DD, YYYY");
      let daysLeft = endDate.diff(startDate, "days");

      let startDateFrom = moment(activationDate, " MMM DD, YYYY");
      let endDateFrom = moment(validToDate, " MMM DD, YYYY");
      let totalDaysLeft = endDateFrom.diff(startDateFrom, "days");
      setTotalDays(totalDaysLeft);
      setDaysLeft(daysLeft);
    }
  }, [userAccountInfo, usageAccountInfo, subscriptionaccountInfo]);

  return (
    <>
      <div id="userpage" className="row pl-3 pr-3">
        <div className="headername">
          <div className="font-weight-bold mb-1 ">
            <h3>
              Hello {userAccountInfo?.firstName} {userAccountInfo?.lastName} !
            </h3>
          </div>

          <div className="buttons-container socialgroup">
            <div
              style={{ paddingTop: 35 }}
              className=" datetime fs-17 font-weight-bold "
            >
              {moment().format(" D MMMM YYYY, h:mm a")}
            </div>
            <div
              style={{ marginTop: 28 }}
              className="renewbtn btn btn-outline-secondary pr-1 mr-2"
            >
              <i className="fs-16 mr-1  la la-hand-point-up"></i>Renew Plan
            </div>
          </div>
        </div>

        <div>
          <div className=" card shadow card-body">
            <div className="executiveheader">
              <div
                className="executivelogobox"
                style={{ textTransform: "uppercase" }}
              >
                {userAccountInfo?.firstName?.[0]}
                {userAccountInfo?.lastName?.[0]}
              </div>

              <div className="executivedescbox ">
                <div className="row mb-2">
                  <div className="col pl-4">
                    <div className="fs-12 font-weight-bold">
                      Company <div className="font-weight-normal">{userAccountInfo?.companyName || "NA"}</div>
                    </div>
                  </div>

                  <div id="lahover" className="col">
                    <div
                      style={{ fontSize: 14, fontWeight: 600 }}
                      className=" btn-outlineblack"
                    >
                      Subscription{" "}
                      <i className="fs-16 mr-1  la la-clipboard-check"></i>
                    </div>
                  </div>

                  <div className="col"> </div>
                </div>

                <div className="row pt-2 mb-2">
                  <div className="col">
                    <div className="fs-12 font-weight-bold">Email</div>
                    <div className="fs-12 font-weight-normal">
                      {userAccountInfo?.email}
                    </div>
                  </div>
                  <div className="col">
                    <div className="fs-12 font-weight-bold">
                      Amount (&#x20b9;)
                    </div>
                    <div className="font-weight-normal">
                      {subscriptionaccountInfo?.amountPaid}
                    </div>
                  </div>
                  <div className="col">
                    <div className="fs-12 font-weight-bold">
                      Activation Date
                    </div>
                    <div className="font-weight-normal">
                    {moment(subscriptionaccountInfo?.trialPeriodStartDate).utc().format("D MMMM YYYY") || ""}
                    
                      {/* {subscriptionaccountInfo?.offerStartDate
                        ? moment(subscriptionaccountInfo?.offerStartDate)
                          .utc()
                          .format(" MMM DD, YYYY")
                        : ""} */}
                    </div>
                  </div>
                </div>

                <div className="row pt-2">
                  <div className="col">
                    <div className="fs-12 font-weight-bold">Phone</div>
                    <div className="fs-12 font-weight-Normal">{userAccountInfo?.mobileNo || "NA"}</div>
                  </div>
                  <div className="col">
                    <div className="fs-12 font-weight-bold">Days Left</div>
                    <div className="fs-12 font-weight-normal">
                      {daysLeft} / {totalDays}
                    </div>
                  </div>
                  <div className="col">
                    <div className="fs-12 font-weight-bold">Renewal Date</div>
                    <div className="fs-12 font-weight-normal">
                      {/* {renewalDate} */} {moment(subscriptionaccountInfo?.validTo).utc().add(1, "d").format("D MMMM YYYY")}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UserInfoHeader;
